import { useEffect, useState } from "react";
import api, { apiError } from "../lib/api";
import { fmtDate } from "../lib/format";
import { PageHeader } from "../components/Common";
import { Plus, Trash, X, User } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function Users() {
  const [items, setItems] = useState([]);
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState({ name: "", email: "", password: "", role: "staff" });

  const load = () => api.get("/users").then(({ data }) => setItems(data));
  useEffect(() => { load(); }, []);

  const openNew = () => { setForm({ name: "", email: "", password: "", role: "staff" }); setModal(true); };

  const save = async (e) => {
    e.preventDefault();
    try {
      await api.post("/auth/register", form);
      toast.success("Kullanıcı eklendi");
      setModal(false); load();
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail));
    }
  };
  const remove = async (id) => {
    try { await api.delete(`/users/${id}`); toast.success("Kullanıcı silindi"); load(); }
    catch (err) { toast.error(apiError(err.response?.data?.detail)); }
  };

  return (
    <div className="p-8 max-w-[1100px]">
      <PageHeader title="Kullanıcılar" subtitle="Ekip üyeleri ve erişim yetkileri" action={
        <button onClick={openNew} data-testid="add-user-button" className="bg-zinc-950 text-white rounded-sm px-4 py-2.5 text-sm font-semibold hover:bg-zinc-800 transition-colors flex items-center gap-2">
          <Plus size={16} weight="bold" /> Kullanıcı Ekle
        </button>
      } />

      <div className="bg-white border border-zinc-200 rounded-sm overflow-hidden animate-fade-up" data-testid="users-table">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-zinc-200 bg-zinc-50">
              <th className="text-left font-semibold text-zinc-600 px-4 py-3 text-xs uppercase tracking-wider">Ad</th>
              <th className="text-left font-semibold text-zinc-600 px-4 py-3 text-xs uppercase tracking-wider">E-posta</th>
              <th className="text-center font-semibold text-zinc-600 px-4 py-3 text-xs uppercase tracking-wider">Rol</th>
              <th className="text-left font-semibold text-zinc-600 px-4 py-3 text-xs uppercase tracking-wider">Oluşturma</th>
              <th className="px-4 py-3"></th>
            </tr>
          </thead>
          <tbody>
            {items.map((u) => (
              <tr key={u.id} className="border-b border-zinc-100 hover:bg-zinc-50 transition-colors" data-testid={`user-row-${u.id}`}>
                <td className="px-4 py-3"><span className="inline-flex items-center gap-2 font-medium text-zinc-900"><User size={16} className="text-zinc-400" />{u.name}</span></td>
                <td className="px-4 py-3 text-zinc-600">{u.email}</td>
                <td className="px-4 py-3 text-center">
                  <span className={`inline-flex text-[11px] font-semibold px-2.5 py-0.5 rounded-full border ${u.role === "admin" ? "bg-blue-50 text-blue-700 border-blue-200" : "bg-zinc-100 text-zinc-600 border-zinc-200"}`}>
                    {u.role === "admin" ? "Yönetici" : "Personel"}
                  </span>
                </td>
                <td className="px-4 py-3 font-mono text-xs text-zinc-500">{fmtDate(u.created_at)}</td>
                <td className="px-4 py-3 text-right">
                  {u.role !== "admin" && <button onClick={() => remove(u.id)} data-testid={`delete-user-${u.id}`} className="p-1.5 text-zinc-400 hover:text-red-600 transition-colors"><Trash size={16} /></button>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {modal && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4" onClick={() => setModal(false)}>
          <form onClick={(e) => e.stopPropagation()} onSubmit={save} className="bg-white rounded-sm border border-zinc-200 w-full max-w-md p-6 animate-fade-up" data-testid="user-modal">
            <div className="flex items-center justify-between mb-6">
              <h3 className="font-display text-xl font-semibold">Yeni Kullanıcı</h3>
              <button type="button" onClick={() => setModal(false)}><X size={20} className="text-zinc-400 hover:text-zinc-900" /></button>
            </div>
            <div className="space-y-4">
              <F label="Ad Soyad"><input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="user-name" className="inp" /></F>
              <F label="E-posta"><input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="user-email" className="inp" /></F>
              <F label="Şifre"><input type="password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="user-password" className="inp" /></F>
              <F label="Rol">
                <select value={form.role} onChange={(e) => setForm({ ...form, role: e.target.value })} data-testid="user-role" className="inp">
                  <option value="staff">Personel</option>
                  <option value="admin">Yönetici</option>
                </select>
              </F>
            </div>
            <button type="submit" data-testid="user-submit" className="w-full mt-6 bg-zinc-950 text-white rounded-sm py-2.5 text-sm font-semibold hover:bg-zinc-800 transition-colors">Kaydet</button>
          </form>
        </div>
      )}
    </div>
  );
}

function F({ label, children }) {
  return (<div><label className="block text-xs uppercase tracking-[0.15em] font-semibold text-zinc-500 mb-1.5">{label}</label>{children}</div>);
}
